import React, { useState, useEffect, useLayoutEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useContext } from 'react';
import { classNameTriskeleParser } from '../../../utilities/customStyles';
import { decrementMonth, incrementMonth, setSelectedDate } from '../../../redux/actions/selectedDateActions';

import globalContext from '../../../context/GlobalContext';
import { compareDates } from '../../../utilities/dates';
import GeneralAccess from '../../../dataAccess/GeneralAccess';
import { isTextEmpty } from '../../../utilities/utils';
import { DayofWeek } from '../../../utilities/generatedClasses';
import { Dialog, makeStyles } from '@mui/material';
import { use } from 'react';
import { useNavigate, useNavigation, useSearchParams } from 'react-router-dom';

// Get Selected Months from Data and populate it in calendar dialog

const CalendarDialog = (props) => {
  const { onClose, selectedValue, open } = props;

  const [header, setHeader] = useState();
  const [table, setTable] = useState([]);
  const [index, selectedIndex] = useState(-1);
  const [itemIndex, selectedItemIndex] = useState(-1);
  const dispatch = useDispatch();
  const context = useContext(globalContext);
  const navigate = useNavigate()
  const topFilterData = useSelector(state => state.widgetFiltes);

  const calendarIcon = document.getElementById('calendarIconButton');
  const spaceFromTop = calendarIcon ? window.pageYOffset + calendarIcon.getBoundingClientRect().top : 0;

  // classes
  const monthBackgroundRectangleTriskeleClass = classNameTriskeleParser('Month Selector', 'Background', 'Rectangle');
  const monthBackIconTriskeleClass = classNameTriskeleParser('Month Selector', 'Back Chevron', 'Icon');
  const monthFrontIconTriskeleClass = classNameTriskeleParser('Month Selector', 'Front Chevron', 'Icon');
  const weekSelectedTriskeleClass = classNameTriskeleParser('Month Selector', 'Week', 'Rectangle', 'Selected');

  const [searchParams] = useSearchParams();
    const clientId = searchParams.get("clientid");
  // const classes = makeStyles({
  //   dialog: {
  //     position: 'absolute',
  //     left: -30,
  //     top: spaceFromTop,
  //     height: 290,
  //   },
  // })();

  const handleClose = () => {
    onClose(selectedValue);
  };

  useLayoutEffect(() => {
    callTriskeleApi();
  }, [topFilterData.selectedDate]);

  const callTriskeleApi = () => {
    GeneralAccess.getMonthlyView(topFilterData.selectedDate, 0, clientId)
      .then((response) => {
        const newData = response.data;
        if (newData.length > 0) {
          populateCalendarUI(newData);
        }
      })
      .catch((error) => {
        console.error(error);
        navigate('/maintenance');
      });
  };

  const setDefaultSelected = (myTable) => {
    myTable.forEach((row, indexRow) => {
      row.forEach((column, indexColumn) => {
        if (column && column.date && topFilterData.selectedDate && compareDates(column.date, topFilterData.selectedDate)) {
          selectRowAction(indexRow, indexColumn, false);
        }
      });
    });
  };

  useEffect(() => {
    setDefaultSelected(table);
  }, [table]);

  const populateCalendarUI = (data) => {
    let daysOfTheWeek = getWeekDaysNamesFromApiData(data);
    const daysInTheWeek = getWeekDaysValuesFromApiData(data);

    daysOfTheWeek = handleMissingWeekDaysName(data, daysOfTheWeek);

    const header = getHeaderFromApiData(data);

    setHeader(header);
    const table = generateTable(daysInTheWeek, daysOfTheWeek);
    setTable(table);
  };


  const selectRowAction = (tRowIndex, titemIndex, isDateSelecting) => {
    if ((tRowIndex !== 0 && tRowIndex !== index) || (tRowIndex !== 0 && itemIndex !== titemIndex)) {
      selectedIndex(-1);
      selectedItemIndex(-1);
      setTimeout(() => {
        if (isDateSelecting) {
          let newDate = table[tRowIndex][titemIndex].date;
          newDate = new Date(newDate).toLocaleDateString('en-US');
          dispatch(setSelectedDate(newDate));
        }
        selectedIndex(tRowIndex);
        selectedItemIndex(titemIndex);
      }, 0);
    }
  };


  const handleMissingWeekDaysName = (data, daysOfWeek) => {
    data
      .filter(item => item.PrcsParmtrValueOne === 'Calendar')
      .map((calendarItem) => {
        const find = daysOfWeek.find(
          item => item.name === calendarItem.DayofWeek
        );
        if (!find) {
          const defClass = daysOfWeek && daysOfWeek.length > 0 && daysOfWeek[0] ? daysOfWeek[0].triskeleClass.text : DayofWeek;
          daysOfWeek.push({ name: calendarItem.DayofWeek, triskeleClass: { text: defClass } });
        }
      });
    return [...daysOfWeek];
  };

  const getWeekDaysNamesFromApiData = data => data
    .filter(item => item.PrcsParmtrValueOne === 'Day of Week')
    .map(calendarItem => ({
      name: calendarItem.DayofWeek,
      triskeleClass: {
        selected: '',
        unselected: '',
        text: classNameTriskeleParser(calendarItem.VisualNameOne, calendarItem.VisualTypeOne, 'Text'),
        icon: '',
      }
    }));

  const getWeekDaysValuesFromApiData = data => data
    .filter(item => item.PrcsParmtrValueOne === 'Calendar')
    .map((calendarItem) => {
      const itemDateBox = classNameTriskeleParser.bind(
        this,
        calendarItem.VisualNameOne,
        calendarItem.VisualTypeOne
      );

      return {
        date: calendarItem.Date,
        name: parseInt(calendarItem.Day, 0),
        dayofWeek: calendarItem.DayofWeek,
        isRecommendation: calendarItem.IsRcmndtn,
        triskeleClass: {
          selected: itemDateBox('Rectangle', 'Selected'),
          unselected: itemDateBox('Rectangle', 'Unselected'),
          text: itemDateBox('Text'),
          icon: !isTextEmpty(calendarItem.VisualNameTwo) && !isTextEmpty(calendarItem.VisualTypeTwo)
            ? classNameTriskeleParser(calendarItem.VisualNameTwo, calendarItem.VisualTypeTwo, 'Circle')
            : ''
        }
      };
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  const getHeaderFromApiData = (data) => {
    let headerItem = null;
    data
      .filter(item => item.PrcsParmtrValueOne === 'Header')
      .forEach((calendarItem) => {
        if (calendarItem.PrcsParmtrValueOne === 'Header') {
          headerItem = {
            name: calendarItem.Month,
            year: parseInt(calendarItem.Year, 0),
            triskeleClass: {
              text: classNameTriskeleParser(calendarItem.VisualNameOne, calendarItem.VisualTypeOne, 'Text')
            },
          };
        }
      });
    return headerItem;
  };

  const createTableArray = (rowIndex, columnIndex, daysOfTheWeek, daysInTheWeek) => {
    if (rowIndex === 0) {
      return daysOfTheWeek[columnIndex];
    }
    if (
      daysInTheWeek[0]
        && daysInTheWeek[0].dayofWeek === daysOfTheWeek[columnIndex].name
    ) {
      return daysInTheWeek.shift();
    }
    return { name: '', triskeleClass: { text: '' } };
  };

  const generateTable = (daysInTheWeek, daysOfTheWeek) => Array(Math.ceil(daysInTheWeek.length / daysOfTheWeek.length) + 1)
    .fill()
    .map((row, rowIndex) => Array(daysOfTheWeek.length)
      .fill(null)
      .map((column, columnIndex) => createTableArray(rowIndex, columnIndex, daysOfTheWeek, daysInTheWeek)));

  
  return (
    <div className="calendar-dialog">
      <Dialog
        onClose={handleClose}
        open={open}
        classes={{ paper: `${monthBackgroundRectangleTriskeleClass} height-auto calendar-position` }}
      >
        <div className="calendar-dialog">
          {header && (
            <div className="calendar-dialog-main-header">
              <span
                onClick={() => {
                  dispatch(decrementMonth());
                }}
                className={`calendar-dialog-main-header-left-arrow ${monthBackIconTriskeleClass}`}
                aria-hidden
              >{'<'}
              </span>
              <span className={`calendar-dialog-main-header-text ${header.triskeleClass.text}`}>
                {`${header.name} ${header.year}`}
              </span>
              <span
                onClick={() => {
                  dispatch(incrementMonth());
                }}
                className={`calendar-dialog-main-header-right-arrow ${monthFrontIconTriskeleClass}`}
                aria-hidden
              >{'>'}
              </span>
            </div>
          )}
          <table className="calendar-dialog-main-table">
            <tbody>
              {table
                && table.map((tRow, tRowIndex) => (
                  <tr
                    key={`${tRowIndex}row`}
                    className={`calendar-dialog-main-table-row ${tRowIndex === index ? `calendar-dialog-main-table-row-selected ${weekSelectedTriskeleClass}` : ''}`}
                  >
                    {tRow
                      && tRow.map((item, titemIndex) => (
                        <td
                          key={`${titemIndex}item`}
                          onClick={() => selectRowAction(tRowIndex, titemIndex, true)}
                          className="calendar-dialog-main-table-cell"
                          style={{ alignItems: 'center' }}
                          aria-hidden
                        >
                          <div
                            style={{
                              display: 'flex', flexDirection: 'column', height: '100%', padding: '10px 0', rowGap: '5px', position: 'relative',
                            }}
                            className={`calendar-dialog-main-table-cell-inner ${item.triskeleClass.text} ${titemIndex == itemIndex && tRowIndex == index ? item.triskeleClass.selected : ''} ${tRowIndex != index ? item.triskeleClass.unselected : ''}`}>
                            <div> <span className={tRowIndex !== 0 ? 'calendar-value' : ''}>{item.name}</span></div>
                            {item.isRecommendation === '1'
                            && <div className={item.triskeleClass.icon} style={{ position: 'absolute', bottom: '2px'}} />
                            }

                          </div>


                        </td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Dialog>
    </div>
  );
};
export default CalendarDialog;
